import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';

import Collection from './account-template-collection.js';

import RefData from '../../ref-data';

function fetch(status, sort = 'lastUpdated', order = 'desc', offset = 0, max = 500) {
  return ajaxService
    .get('/api/xp/campaign/list.json', {
      status: RefData.Enum.STATUS.CAMPAIGNOBJECT.TEMPLATE,
      sort,
      order,
      offset,
      max,
      brief:  true,
    })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(Collection.deserialize);
}

export default {
  fetch,
};
